import { Component, ElementRef, input, model, output, viewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SynIconComponent, SynSwitchComponent } from '@synergy-design-system/angular';

type OnChangeFn = (value: boolean) => unknown;
type OnTouchedFn = () => unknown;

@Component({
  selector: 'app-toggle-switch',
  template: `
    <div class="flex-row col-gap-1">
      <syn-switch
        [disabled]="disabled()"
        [checked]="checked()"
        size="large"
        (synChangeEvent)="onInput($event)"
        (synBlurEvent)="onBlur($event)"
        #element
      >
      </syn-switch>
      @if (iconOn()) {
        <syn-icon style="font-size: var(--syn-font-size-large);" [name]="checked() ? iconOn() : iconOff()"> </syn-icon>
      }
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ToggleSwitchComponent,
    },
  ],
  imports: [SynSwitchComponent, SynIconComponent],
})
export class ToggleSwitchComponent implements ControlValueAccessor {
  disabled = model(false);
  checked = model(false);
  invalid = input(false);
  iconOn = input('');
  iconOff = input('');

  change = output<boolean>();

  element = viewChild.required<ElementRef<HTMLInputElement>>('element');

  private touched = false;
  private onChange: OnChangeFn = () => {};
  private onTouched: OnTouchedFn = () => {};

  writeValue(value: boolean): void {
    this.checked.set(value);
  }
  registerOnChange(onChange: OnChangeFn): void {
    this.onChange = onChange;
  }
  registerOnTouched(onTouched: OnTouchedFn): void {
    this.onTouched = onTouched;
  }
  setDisabledState?(disabled: boolean): void {
    this.disabled.set(disabled);
  }

  onInput(event: Event) {
    if (event.target === this.element().nativeElement) {
      this.checked.set((event.target as HTMLInputElement).checked);
      this.onChange(this.checked());

      this.change.emit(this.checked());
    }
  }

  onBlur(event: Event) {
    if (event.target === this.element().nativeElement) {
      if (this.touched) return;
      this.onTouched();
      this.touched = true;
    }
  }
}
